import { render, staticRenderFns } from "./PeriodLevel2.vue?vue&type=template&id=f6d8fbca&scoped=true"
import script from "./PeriodLevel2.vue?vue&type=script&lang=js"
export * from "./PeriodLevel2.vue?vue&type=script&lang=js"
import style0 from "./PeriodLevel2.vue?vue&type=style&index=0&id=f6d8fbca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d8fbca",
  null
  
)

export default component.exports